/**
 * Componente ListaCompras
 * Muestra la lista de compras registradas
 */

import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
} from '@mui/material';
import { Add } from '@mui/icons-material';

const ListaCompras = ({ compras = [], loading, onNuevaCompra }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Compras Registradas</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={onNuevaCompra}>
          Nueva Compra
        </Button>
      </Box>

      {compras.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            No hay compras registradas. Haga clic en "Nueva Compra" para comenzar.
          </Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>N° Factura</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell>Proveedor</TableCell>
                <TableCell align="right">Subtotal</TableCell>
                <TableCell align="right">IVA</TableCell>
                <TableCell align="right">Total</TableCell>
                <TableCell align="center">Estado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {compras.map((compra) => (
                <TableRow key={compra.id}>
                  <TableCell>{compra.numero_factura}</TableCell>
                  <TableCell>{compra.fecha_factura}</TableCell>
                  <TableCell>{compra.proveedor_nombre || '-'}</TableCell>
                  <TableCell align="right">
                    ${parseFloat(compra.subtotal || 0).toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    ${parseFloat(compra.iva || 0).toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    ${parseFloat(compra.total || 0).toFixed(2)}
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={compra.estado || 'BORRADOR'}
                      color={compra.estado === 'APROBADA' ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default ListaCompras;
